import { render } from "./PotEditor.vue?vue&type=template&id=4819bb1f&ts=true"
import script from "./PotEditor.vue?vue&type=script&lang=ts"
export * from "./PotEditor.vue?vue&type=script&lang=ts"

import "./PotEditor.vue?vue&type=style&index=0&id=4819bb1f&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__